import urlReducer from "./url";
import authenticatedReducer from "./authenticated";
import userReducer from "./user";
import interventionReducer from "./intervention"; //inhoud vd interventie
import questionnaireReducer from "./questionnaire"; //inhoud ve questionnaire
import medialibraryReducer from "./medialibrary";
import badgeLibraryReducer from "./badgelibrary";
import answersLessonsReducer from "./answers_lessons"; //antwoorden
import pageHistoryReducer from "./page_history";
import activeInterventionReducer from "./active_intervention"; //actieve interventie
import activeLessonReducer from "./active_lesson"; //lesson_id igv activePart = lesson
import activeGoalReducer from "./active_goal"; //lesson_id igv activePart = lesson
import activeSubLessonReducer from "./active_sub_lesson"; //sub_lesson_id -> lessons met dividers
import previousLessonsReducer from "./previous_lessons";
import finishedCourseReducer from "./course_finished"; //voor de confetti
import showLeftMenuReducer from "./show_left_menu"; //voor de confetti
import activePartReducer from "./active_part"; //lessons, lesson, goals, stress, chat, settings,
import activeLanguageReducer from "./active_language"; //taal die student actief heeft
import activePageReducer from "./active_page"; //page_id igv activePart = page
import translationReducer from "./translation";
import activeTranslationTabReducer from "./active_translation_tab";
import uiTranslationReducer from "./ui_translation";
//import sleepDiaryReducer from "./sleep_diary";
import newBadgesReducer from "./rewards";
import { combineReducers } from "redux";

const allReducers = combineReducers({
  url: urlReducer,
  auth: authenticatedReducer,
  user: userReducer,
  intervention: interventionReducer,
  questionnaire: questionnaireReducer,
  mediaLibrary: medialibraryReducer,
  badgeLibrary: badgeLibraryReducer,
  answersLessons: answersLessonsReducer,
  pageHistory: pageHistoryReducer,
  activeIntervention: activeInterventionReducer,
  activeLesson: activeLessonReducer,
  activeSubLesson: activeSubLessonReducer,
  activePart: activePartReducer,
  activePage: activePageReducer,
  activeGoal: activeGoalReducer,
  finishedCourse: finishedCourseReducer,
  showLeftMenu: showLeftMenuReducer,
  activeLanguage: activeLanguageReducer,
  previousLessons: previousLessonsReducer,
  translation: translationReducer,
  activeTranslationTab: activeTranslationTabReducer,
  uiTranslation: uiTranslationReducer,
  newBadges: newBadgesReducer,
});

const appReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined;
  }

  return allReducers(state, action);
};

export default appReducer;
